import styled from "styled-components";

const CtaContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 10px 0 10px 0;
`

export default CtaContainer
